"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQualitativeScale = createQualitativeScale;
var color_1 = require("../../color");
var conversions_1 = require("../../conversions");
/**
 * Creates a qualitative color scale.
 *
 * This function generates a set of distinct colors that are easily distinguishable from each other,
 * which is useful for representing categorical data.
 *
 * @param {number} numberOfColors - The number of distinct colors to generate.
 * @returns {Color[]} An array of distinct Color objects.
 *
 * @example
 * const categoricalColors = createQualitativeScale(5);
 * // Returns an array of 5 distinct Color objects
 */
function createQualitativeScale(numberOfColors) {
    if (numberOfColors < 1) {
        throw new Error('Number of colors must be at least 1');
    }
    var goldenRatioConjugate = 0.618033988749895;
    var scale = [];
    for (var i = 0; i < numberOfColors; i++) {
        var hue = (i * goldenRatioConjugate) % 1;
        var saturation = 0.5 + Math.random() * 0.3; // 0.5 to 0.8
        var lightness = 0.4 + Math.random() * 0.2; // 0.4 to 0.6
        var rgb = (0, conversions_1.hslToRgb)({ h: hue * 360, s: saturation * 100, l: lightness * 100 });
        scale.push(new color_1.Color(rgb));
    }
    return scale;
}
